module.exports = __webpack_public_path__ + "img/icon-excel.14320a0d.svg";